import { createVNode as _createVNode, resolveComponent as _resolveComponent } from "vue";
import { defineComponent, reactive, onMounted, computed } from "vue";
import { useRouter, useRoute } from "vue-router";
import { start } from "qiankun";
export default defineComponent({
  setup() {
    const currentRouter = useRoute();
    onMounted(() => {
      if (!window.qiankunStarted) {
        window.qiankunStarted = true;
        start({
          prefetch: true,
          // 开启预加载
          sandbox: {
            // strictStyleIsolation: true,
            // experimentalStyleIsolation: true
          }
        });
      }
    });
    return {
      currentRouter
    };
  },
  render() {
    return _createVNode(_resolveComponent("el-main"), {
      "class": "layout-appMain"
    }, {
      default: () => [_createVNode(_resolveComponent("router-view"), {
        "key": this.currentRouter.fullPath
      }, null)]
    });
  }
});